import React, { useState } from 'react';
import { toast } from 'sonner';
import { Link2, X } from 'lucide-react';

// ===================================================================
export function LinkSameInvoiceModal({ count, onClose, onApply }) {
  const [num, setNum] = useState('');
  const [date, setDate] = useState('');
  const [amount, setAmount] = useState('');

  const handleApply = () => {
    if (!num.trim()) {
      toast.error('رقم الفاتورة مطلوب');
      return;
    }
    onApply({
      invoice_number: num.trim(),
      invoice_date: date || null,
      amount: amount ? parseFloat(amount) : null,
    });
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4" dir="rtl" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden"
      >
        <div className="bg-gradient-to-l from-purple-600 to-fuchsia-600 text-white px-5 py-4 flex items-center gap-3">
          <Link2 className="w-5 h-5" />
          <div className="flex-1">
            <h3 className="font-bold text-base">ربط بنفس الفاتورة</h3>
            <p className="text-xs opacity-90">سيتم ربط {count} استلامات بنفس بيانات الفاتورة</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-5 space-y-3">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">رقم الفاتورة *</label>
            <input
              type="text"
              value={num}
              onChange={(e) => setNum(e.target.value)}
              placeholder="مثال: INV-100"
              data-testid="link-invoice-number"
              autoFocus
              className="w-full h-11 px-3 border-2 border-gray-200 rounded-lg text-sm font-semibold focus:border-purple-500 outline-none"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">تاريخ الفاتورة</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              data-testid="link-invoice-date"
              className="w-full h-11 px-3 border-2 border-gray-200 rounded-lg text-sm focus:border-purple-500 outline-none"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">المبلغ الإجمالي للفاتورة</label>
            <input
              type="number"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="يُدخل مرة واحدة فقط"
              data-testid="link-invoice-amount"
              className="w-full h-11 px-3 border-2 border-gray-200 rounded-lg text-sm focus:border-purple-500 outline-none"
            />
            <p className="text-[11px] text-gray-500 mt-1">المبلغ يُحتسب مرة واحدة في إجمالي الكشف.</p>
          </div>
        </div>

        <div className="border-t bg-gray-50 px-5 py-3 flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 h-11 rounded-lg border-2 border-gray-200 text-gray-700 font-semibold hover:bg-white"
          >
            إلغاء
          </button>
          <button
            onClick={handleApply}
            data-testid="link-apply-btn"
            className="flex-1 h-11 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-bold flex items-center justify-center gap-1.5"
          >
            <Link2 className="w-4 h-4" /> ربط
          </button>
        </div>
      </div>
    </div>
  );
}


// ===================================================================
// 8) Add Receipts To Sheet Modal — إضافة استلامات لكشف موجود
